<template>
  <div class="lofistcs-dialog">
    <el-dialog
      title="编辑发货信息"
      :visible.sync="dialogVisible"
      width="60%"
      :before-close="close"
      :modal-append-to-body="false"
    >
      <TableList
        :loading="loading"
        :table-data="tableData"
        :table-label="tableLabel"
      >
        <template v-slot:eventTimeStr="slot">
          <div class="eventTimeStr">
            <el-date-picker
              v-model="lastLogistcsData.eventTimeStr"
              type="datetime"
              value-format="yyyy-MM-dd hh:mm:ss"
              placeholder="选择日期时间"
              v-if="slot.scope.$index + 1 == tableData.length"
            >
            </el-date-picker>
            <div v-else>{{ slot.scope.row.eventTime }}</div>
          </div>
        </template>
        <template v-slot:eventAddress="slot">
          <el-input
            v-model="lastLogistcsData.eventAddress"
            placeholder="请输入地址"
            v-if="slot.scope.$index + 1 == tableData.length"
          ></el-input>
          <div v-else>{{ slot.scope.row.eventAddress }}</div>
        </template>
        <template v-slot:statusCodeStr="slot">
          <el-select
            v-model="lastLogistcsData.statusCode"
            placeholder="请选择状态"
            v-if="slot.scope.$index + 1 == tableData.length"
          >
            <el-option
              v-for="item in status"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
          <div v-else>{{ slot.scope.row.statusCodeStr }}</div>
        </template>
        <template v-slot:linkmanName="slot">
          <el-input
            v-model="lastLogistcsData.linkmanName"
            placeholder="请输入联系人姓名"
            v-if="slot.scope.$index + 1 == tableData.length"
          ></el-input>
          <div v-else>{{ slot.scope.row.linkmanName }}</div>
        </template>
        <template v-slot:linkmanMobile="slot">
          <el-input
            v-model="lastLogistcsData.linkmanMobile"
            placeholder="请输入联系人电话"
            v-if="slot.scope.$index + 1 == tableData.length"
          ></el-input>
          <div v-else>{{ slot.scope.row.linkmanMobile }}</div>
        </template>
      </TableList>
      <span slot="footer" class="dialog-footer">
        <el-button @click="close">取 消</el-button>
        <el-button type="primary" @click="submit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import TableList from "../../components/common/e-table-list";
import api from "../../api/order";
export default {
  name: "logistcsDialog",
  components: { TableList },
  props: {
    dialogVisible: Boolean,
    logistcsDialogData: Object,
    handleClose: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      lastLogistcsData: {
        eventTimeStr: "",
        eventAddress: "",
        linkmanMobile: "",
        linkmanName: "",
        logisticsId: "",
        statusCode: "",
      },
      status: [
        { value: "2", label: "出库" },
        { value: "1", label: "分拣" },
        { value: "3", label: "中转" },
        { value: "4", label: "签收" },
      ],
      loading: false,
      tableData: [],
      tableLabel: [
        {
          label: "时间",
          param: "eventTimeStr",
          slot: "eventTimeStr",
          align: "center",
          fixed: "left",
        },
        {
          label: "地点",
          param: "eventAddress",
          slot: "eventAddress",
          align: "center",
          fixed: "left",
        },
        {
          label: "状态",
          param: "statusCodeStr",
          slot: "statusCodeStr",
          align: "center",
        },
        {
          label: "联系人姓名",
          param: "linkmanName",
          slot: "linkmanName",
          align: "center",
        },
        {
          label: "联系人电话",
          param: "linkmanMobile",
          slot: "linkmanMobile",
          align: "center",
        },
      ],
    };
  },
  methods: {
    submit() {
      if (!this.lastLogistcsData.eventTimeStr) {
        this.$message.error("请选择时间");
        return;
      }
      if (!this.lastLogistcsData.eventAddress) {
        this.$message.error("请填写地址");
        return;
      }
      if (!this.lastLogistcsData.statusCode) {
        this.$message.error("请填写状态");
        return;
      }
      if (!this.lastLogistcsData.linkmanName) {
        this.$message.error("请填写联系人姓名");
        return;
      }
      if (!this.lastLogistcsData.linkmanMobile) {
        this.$message.error("请填写联系人电话");
        return;
      }
      // this.lastLogistcsData.logisticsId = this.logistcsDialogData.orderShipmentId;
      // this.lastLogistcsData.logisticsId = this.tableData[0].logisticsId;
      api.saveLogisticsTrack(this.lastLogistcsData).then((res) => {
        if (res.code == "200") {
          this.$message.success("发货信息填写成功");
          this.close();
        } else {
          this.$message.error(res.message);
        }
      });
    },
    queryLogisticsList() {
      api
        .queryLogisticsList({ ...this.logistcsDialogData, flag: "ASC" })
        .then((res) => {
          if (res.code == "200" && res.data.length > 0) {
            this.lastLogistcsData.logisticsId = res.data[0].logisticsId;
            res.data.forEach((item) => {
              if (item.logisticsTrackVOs) {
                item.logisticsTrackVOs.forEach((data) => {
                  this.tableData.push(data);
                });
              }
            });
          }
          this.tableData.push({
            eventTimeStr: "",
            eventAddress: "",
            statusCodeStr: "",
            linkmanName: "",
            linkmanMobile: "",
          });
        });
    },
    close() {
      this.handleClose();
    },
  },
  mounted() {
    this.queryLogisticsList();
  },
};
</script>

<style scoped lang="scss">
.eventTimeStr {
  ::v-deep .el-date-editor.el-input,
  .el-date-editor.el-input__inner {
    width: 184px;
  }
}
</style>